import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { agentOutwardService } from "../../../services/agentoutward.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap";



import { Combo2Service } from "../../../services/index";
import { outwardPrint } from "./outwardPrint";
declare var google;

@Component({
  selector: "agentOutward",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./agentOutward.html",
})
export class agentOutwardComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;

  filter = {
    type: "",
    ref_no: "",
    dcid: "",
    finyear : '',
    fin_id : ''
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "po_id",
    orderDir: "desc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  stockType: any;
  partyList = [];
  invList = [];
  

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("printTemplate") printTemplate: TemplateRef<any>;
  @ViewChild("invoiceTemplate") invoiceTemplate: TemplateRef<any>;
  @ViewChild("detailsTemplate") detailsTemplate: TemplateRef<any>;
  @ViewChild("convertWTemplate") convertWTemplate: TemplateRef<any>;
  @ViewChild("convertRTemplate") convertRTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("finAuto") finAuto;
  @ViewChild("partyAuto") partyAuto;

  finCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  invCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  print: boolean = false;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  invoiceList: any = [];
  totpcs: any;

  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private agentowservice: agentOutwardService,
    private combo2Service: Combo2Service,
    private modalService: BsModalService,
  
  ) {}

  ngOnInit(): void {
    this.finyearCombo();
    this.getstockType();
    this.getColumns();
    this.getSalesAgent();

    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Ref No",
        prop: "ref_no",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Date",
        prop: "ao_date_formatted",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Stock-Type",
        prop: "type",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
      {
        name: "Sales person",
        prop: "agent_name",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
      {
        name: "F.Tot",
        prop: "fspcs",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "H.Tot",
        prop: "hspcs",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Total Pcs",
        prop: "invpcs",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 80,
        maxWidth: 80,
        width: 100,
      },
      {
        name: "Action",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        cellClass: "text-center",
        width: 50,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      },
      {
        name: "Print Details",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        cellClass: "text-center",
        width: 50,
        sortable: false,
        cellTemplate: this.printTemplate,
      },
    ];
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
    a.removeClass("mat-autocomplete-visible");
    setTimeout(function () {
      $("#finyear").focus();
    }, 100);
  }
  getstockType() {
    this.stockType = [
      {
        type: "R & D",
      },
      {
        type: "FAIR",
      },
      {
        type: "SALES PERSON",
      },
      {
        type: "CONFERENCE",
      },
      {
        type: "SUSPENSE",
      },
      {
        type: "FACTORY",
      },
    ];
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 300);
    }
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      //   var temp = ["Core", "All"];
      //   that.finyearList.concat(temp);
         that.finCtrl.setValue(res.data[0].fin_id);
         that.filter.fin_id = res.data[0].fin_id;
       that.filter.finyear = res.data[0].finyear;
       that.agentOutwardList();
    });
  }
  onChangeFinyear(finyear){
      let curfin = _.filter(this.finyearList, {finyear : finyear});
      this.filter.fin_id  = curfin[0]['fin_id'];
  }
  getSalesAgent() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
    };
    this.agentowservice.getSalesAgent(params).then((res: any) => {
      this.agentList = res;
    });
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.agentOutwardList();

  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
  }

  clearFilter(): void {
    this.filter.type = "";
    this.filter.ref_no = "";
    this.applyFilter();
  }

  applyFilter(): void {
    this.filterPanel.close();
    this.agentOutwardList();
  }

  addEditPO(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.agentOutwardList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD STOCK OUTWARD",
          title: "ADD STOCK OUTWARD",
          tabParent: "SALES_PLAN",
          mode: mode,
          data: row,
          name: "ADD STOCK OUTWARD",
        },
      };
    } else {
      tabObj = {
        action: "NewTab",
        params: {
          tabName: "EDIT STOCK OUTWARD",
          title: "EDIT STOCK OUTWARD",
          tabParent: "SALES_PLAN",
          mode: mode,
          data: row,
          name: "EDIT STOCK OUTWARD",
        },
      };
    }
    //test
    this.tabUpdateEvent.emit(tabObj);
  }
  agentOutwardList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      type: this.filter.type,
      ref_no: this.filter.ref_no,
      fin_id : this.filter.fin_id
    };
    let that = this;
    this.isLoadMask = this.agentowservice
      .agentOutwardList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.total;
        that.invoiceList = res.data;
        that.calcTotal();
      });
  }
  PrintagentData(row){
  
      this.bsModalRef = this.modalService.show(outwardPrint, {
        keyboard: false,
        ignoreBackdropClick: true,
        class: "compWidth-70",
      });
      this.bsModalRef.content.printdet = Object.assign({}, row);
    
  
}
bsModalRef: BsModalRef
  calcTotal() {
    for (let i = 0; i < this.invoiceList.length; i++) {
      this.invoiceList[i].ao_date_formatted = this.datePipe.transform(
        this.invoiceList[i].aodt,
        "dd-MM-yyyy"
      );
    }
  }

  onClickInvoice(ref_no) {
    let invlist = _.filter(this.invList, { ref_no: ref_no });
    this.filter.dcid = invlist[0].dcid;
  }

  deleteInvoice(row) {
    let that = this;
    row.tabevent = undefined;
    let params = {
      dcid: row.dcid,
    };
    swal({
      title: "Are you sure to delete this Invoice Details?",
      text: "You will not be able to recover this Invoice",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.agentowservice
          .delete(params)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.agentOutwardList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {}
    );
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/agentOutward/agentOutward.ts